import { ApiEndpoints } from '../constantes/ApiEndpoints';
import { IdentifierType, VerifyAccountRequest, VerifyAccountResponse } from '../_types/account.types';
import { apiUserAccount } from '../../../services/api/ApiService';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

export const verifyAccountService = async (
  identifierType: IdentifierType,
  identifier: string
): Promise<VerifyAccountResponse> => {
  
  const schemaId = getSchemaIdFromStorage();
  
  const requestBody: VerifyAccountRequest = {
    identifierType,
    identifier
  };
  
  return await apiUserAccount.post<VerifyAccountResponse>(`${ApiEndpoints.account.verify}?schemaId=${schemaId}`, requestBody
  );
};
